import type { SelectItemSeparator } from '../../lib/list-selection/types';
import BaseList from './base-list.vue';
import BaseSelectItem from './base-select-item.vue';
import BaseSelectDropdown from './base-select-dropdown.vue';
import BaseSelectList from './base-select-list.vue';
import BaseSelectSeparator from './base-select-separator.vue';

const SELECT_ITEM_SEPARATOR: SelectItemSeparator = {
  type: 'separator',
  disabled: true
};

export { BaseList, BaseSelectItem, BaseSelectList, BaseSelectDropdown, BaseSelectSeparator, SELECT_ITEM_SEPARATOR };
